export default "__VITE_ASSET__tdGc9SJKZi0EdOY8VH_pQA__"